export default __webpack_public_path__ + "static/media/magic-dark.c75cb13b.svg";